
export function Footer() {
    return (
        <footer>
        <address>
          Powered by <a href="https://erp.solinges.com.ar" target="_blank">Solinges Team</a>
        </address>
      </footer>
    )
}